import React, { useState } from 'react';
import ReportcenterFilter from './ReportcenterFilter';
import { Block } from '@upsales/components';
import bemClass from '@upsales/components/Utils/bemClass';
import T from 'Components/Helpers/translate';
import './ReportcenterFilterAppointmentType.scss';
import ReportcenterFilterRow from './ReportcenterFilterRow';
import { removeItem } from 'Store/helpers/array';
import { RCDashboardFilter } from 'Resources/ReportDashboard';
import ActivityType from 'App/resources/Model/ActivityType';
import ReportcenterFilterSearchbar from './ReportcenterFilterSearchbar';

interface Props {
	onChange: (type: keyof RCDashboardFilter, values: number[], comparison: string) => void;
	values: RCDashboardFilter;
	updateFilterHeight: () => void;
}

export const renderSelected = (values: RCDashboardFilter) => {
	let res = `${T('default.appointmentTypes')}: `;
	if (values?.AppointmentType?.value?.length) {
		const length = values.AppointmentType.value.length;
		if (length >= 1) {
			res += `${length} ${(values.AppointmentType.comparison === 'eq'
				? T('default.selected')
				: T('default.excluded', { count: length })
			).toLowerCase()}`;
		}
	}

	return res;
};

const getAppointmentTypes = (values: RCDashboardFilter) => {
	const appointmentTypes: ActivityType[] = Tools.AppService.getActivityTypes('appointment');
	const shouldFilterFirstAppointmentTypes = !values.AppointmentType?.value;
	return shouldFilterFirstAppointmentTypes ? appointmentTypes.filter(type => type.first) : appointmentTypes;
};

const ReportcenterFilterAppointmentType = ({ onChange, ...props }: Props) => {
	const classes = new bemClass('ReportcenterFilterAppointmentType');
	const [searchStr, setSearchStr] = useState('');
	const appointmentTypes = getAppointmentTypes(props.values);
	const array = appointmentTypes.filter(type => type.name.toLowerCase().indexOf(searchStr.toLowerCase()) !== -1);
	const value = props.values?.AppointmentType?.value || [];
	const comparison = props.values?.AppointmentType?.comparison ?? 'eq';
	const isExclude = comparison === 'ne';

	return (
		<ReportcenterFilter
			className={classes.b()}
			renderSelected={() => renderSelected(props.values)}
			getSelectedNames={() => appointmentTypes.filter(type => value.includes(type.id)).map(type => type.name)}
			icon="opportunity"
			placeholder={`${T('default.appointmentTypes')}: ${T('reportcenter.filter.notActive')}`}
			value={value}
			resetFilter={() => onChange('AppointmentType', [], 'eq')}
			{...props}
		>
			<Block space="ptm prm pbm plm" backgroundColor="white" className={classes.elem('list-select').b()}>
				<Block space="mtm">
					<ReportcenterFilterSearchbar<number[]>
						setSearchStr={value => setSearchStr(value)}
						searchStr={searchStr}
						placeholder={`${T('default.search')} ${T('default.appointmentTypes').toLowerCase()}`}
						isExclude={isExclude}
						onChange={onChange}
						field="AppointmentType"
						value={value}
					/>
				</Block>
			</Block>
			<ReportcenterFilterRow
				key={0}
				onClick={() => {
					onChange('AppointmentType', [], 'eq');
				}}
				selected={!value.length}
				title={T('filters.noFilter')}
			/>
			{array.map(row => (
				<ReportcenterFilterRow
					key={row.id}
					onClick={() => {
						const i = value.indexOf(row.id);
						onChange('AppointmentType', i !== -1 ? removeItem(value, i) : [...value, row.id], comparison);
					}}
					selected={value.indexOf(row.id) !== -1}
					title={row.name}
				/>
			))}
		</ReportcenterFilter>
	);
};

export default ReportcenterFilterAppointmentType;
